export default "__VITE_ASSET__fa079962__"